import { Dispatch } from "redux";
import {
  SendRequestCallback,
  CreateNotificationAction,
  Organization,
  GetOrganizationAction,
} from "../../types";
import { displayErrorNotification } from "../notifications";
import { GET_ORGANIZATION, GET_USER_ORGANIZATIONS } from "../const";

export const getOrganization =
  (sendRequest: SendRequestCallback<undefined, undefined, Organization>) =>
  async (
    dispatch: Dispatch<GetOrganizationAction | CreateNotificationAction>,
  ) => {
    try {
      const res = await sendRequest("GET")({
        url: `/organization`,
      });
      if (res?.status === 200) {
        dispatch({
          type: GET_ORGANIZATION,
          payload: res.data,
        });
      } else {
        throw Error("Status != 200");
      }
    } catch (error) {
      await displayErrorNotification("Failed to get organization")(dispatch);
    }
  };

/**
 * The organizations this user may act as, in Scout.
 *
 * A backend question, not a client one: the memberships on the token carry only
 * slugs, the display names live in Scout's own database, and the list is already
 * filtered to what this backend will actually serve - so the picker cannot offer
 * something the next request would be refused for.
 */
export const getUserOrganizations =
  (sendRequest: SendRequestCallback<undefined, undefined, any>) =>
  async (dispatch: Dispatch<any>) => {
    try {
      const res = await sendRequest("GET")({
        url: `/organizations`,
      });
      if (res?.status === 200) {
        dispatch({
          type: GET_USER_ORGANIZATIONS,
          payload: res.data?.organizations || [],
        });
      } else {
        throw Error("Status != 200");
      }
    } catch (error) {
      await displayErrorNotification("Failed to get organizations")(dispatch);
    }
  };
